export interface CaasMethod {
  name: string;
  id: number;
  key: string;
}

export const CAAS_METHODS: CaasMethod[] = [
  {
    name: 'Straight Line',
    id: 1,
    key: 'SL'
  },
  {
    name: 'Decline',
    key: 'DL',
    id: 2
  },
  {
    name: 'Double Decline',
    key: 'DDL',
    id: 3
  },
  {
    name: 'Units of Production',
    key: 'UoP',
    id: 4
  },
  {
    name: 'Sum Of Years Digit',
    key: 'SoY',
    id: 5
  }
];
